interface ReviewSectionsItemInterface {
  id: string
  title: string
}

type ReviewSectionsType = ReviewSectionsItemInterface[]

export const reviewSectionsData: ReviewSectionsType = [
  {
    id: 'interior',
    title: 'Interior',
  },
  {
    id: 'performance',
    title: 'Performance',
  },
  {
    id: 'practicality',
    title: 'Practicality',
  },
  {
    id: 'running-costs',
    title: 'Running costs',
  },
  {
    id: 'verdict',
    title: 'Verdict',
  },
]
